exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.timeline-item__date[data-v-791c0f24] {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 1em;\n  line-height: 120%;\n  color: rgba(0, 0, 0, 0.4);\n}\n.timeline-item__title[data-v-791c0f24] {\n  font-style: normal;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 29px;\n  color: #000000;\n}\n.timeline-item[data-v-791c0f24] {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 1em;\n  line-height: 24px;\n  color: #000000;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-791c0f24","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/sales/sale_details/components/UpdatesTab.Timeline.Item.vue
// module id = wp/o
// module chunks = 1